module.exports = __webpack_public_path__ + "logos/logo-campfire.3f5a91.svg";